module.exports = __webpack_public_path__ + "static/img/LogoInforderAdmin.288502b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LogoInforderAdmin.png
// module id = 7VZ7
// module chunks = 1